import { defineStore } from "pinia";
import { ref, computed, type Component } from "vue";
import App500Error from "@/components/errors/App500Error.vue";
import App401Error from "@/components/errors/App401Error.vue";
import App403Error from "@/components/errors/App403Error.vue";

export const useErrorStateStore = defineStore("errorState", () => {
  const status = ref<"ready" | "fault">("ready");
  const lastResponseCode = ref(0);

  const statusPage = computed<Component | null>(() => {
    if (status.value !== "fault") return null;
    switch (lastResponseCode.value) {
      case 401:
        return App401Error;
      case 403:
        return App403Error;
      case 500:
        return App500Error;
      default:
        return App500Error;
    }
  });

  function setFault(responseCode: number) {
    status.value = "fault";
    lastResponseCode.value = responseCode;
  }

  function clearFault() {
    status.value = "ready";
    lastResponseCode.value = 0;
  }

  return {
    status,
    lastResponseCode,
    statusPage,
    setFault,
    clearFault,
  };
});
